import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";
import { ConfigService } from "../../services/config.service";

@Component({
  selector: "page-sc-terms-conditions",
  templateUrl: "sc-terms-conditions.html"
})
export class ScTermsConditionsPage {
  idioma: string;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private configService: ConfigService,
    public viewCtrl: ViewController
  ) {
    this.idioma = this.configService.getIdiom();
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad ScTermsConditionsPage");
  }

  ionViewWillEnter() {}
}



// WEBPACK FOOTER //
// ./src/pages/sc-terms-conditions/sc-terms-conditions.ts